module.exports = __webpack_public_path__ + "f5cb96a7c1274a4b08326746e0a9f761.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/risky-business-chart-img.jpg
// module id = 1926
// module chunks = 0